import { Box, useTheme } from '@mui/material';
import Article from './Article';
import { useAppSelector } from 'hooks/redux.hooks';
import { selectImageUrl, selectTranslations } from 'state/reducers/translation.reducers';

export default function Articles(props: { theme?: string }) {
  const theme = useTheme();
  const t = useAppSelector(selectTranslations);
  const imageUrl = useAppSelector(selectImageUrl);

  const articles = Array.from(Array(3).keys()).map((num: number) => {
    return {
      title: t(`articles.category_${num + 1}.title`),
      subtitle: t(`articles.category_${num + 1}.description.text`),
      image: imageUrl(`articles.category_${num + 1}.image`) || `/static_images/brand-image-${num + 1}.svg`,
      buttonText: t(`articles.category_${num + 1}.button.text`),
      link: t(`articles.category_${num + 1}.link.text`),
    };
  });
  const wrapTheme = props.theme ? {
    background: '#004751', padding: '36px 24px', [theme.breakpoints.down('sm')]: {
      padding: '36px 24px!improtant'
    },
  } : {}
  return (
    <Box
      sx={{
        width: '100%',

        height: 'fit-content',
        borderRadius: '8px',
        display: 'grid',
        gap: '16px',
        gridTemplateColumns: 'repeat(auto-fit, minmax(341px, 1fr))',
        [theme.breakpoints.down('sm')]: {
          padding: '0 12px 12px 12px',
        },
        ...wrapTheme,
      }}
    >
      {articles.map((article: any, index) => {
        return <Article key={index} article={article} />;
      })}
    </Box>
  );
}
